import { useMemo, useEffect, useState } from 'react';
import { Box, Icon, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Button, useTheme, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom"

import { IIndice, IndiceService } from '../../shared/services/api/indice/IndiceService';
import { AlertSnackBar, AutoCompleteDeCliente, FerramentasDaListagem } from "../../shared/components"
import { LayoutBaseDePagina } from "../../shared/layouts"
import { Environment } from '../../shared/environment';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

export const ListagemDeIndiceDesativado: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [rows, setRows] = useState<IIndice[]>([]);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [isLoading, setIsLoading] = useState(true);
  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    handleNewSearch(false);
  }, [cnpj])

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina])

  const handleNewSearch = (newPage: boolean) => {
    setRows([]);
    resetPaginacao();
    setIsLoading(true);
    if (cnpj === undefined || cnpj === null || cnpj === '') {
      setIsLoading(false);
    } else {
      if (newPage) {
        IndiceService.getAll(pagina, cnpj, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setPaginacao(result.paginacao);
            setRows(result.indices);
          }
        })
      } else {
        setSearchParams({ pagina: "1" }, { replace: true })

        IndiceService.getAll(1, cnpj, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setPaginacao(result.paginacao);
            setRows(result.indices);
          }
        })
      }
    }


  };





  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    IndiceService.toggleEnabledById(idToReable)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idIndice !== idToReable),
            ]
          });
          setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Indice reativado com sucesso" });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        }
      });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<number>(0);

  const handleClickReable = (idIndice: number) => {
    setAbrir(true);
    setidToReable(idIndice);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de índices desativados"
      barraDeFerramentas={
        <Box
          component={Paper}
          height={theme.spacing(5)}
          marginX={1}
          padding={1}
          paddingX={2}
          display="flex"
          gap={1}
          alignItems="center"
        >
          <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

          <Box flex={1} display="flex" justifyContent="end">
            <Box width={5}></Box>
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/indice/detalhe/novo')}
            >
              Novo
            </Button>
          </Box>
        </Box>
      }
    >
      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar o indice?"}
        texto={"Ao confirmar, o indice será reativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alertSnackbar !== undefined && (
        <>
          {alertSnackbar.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell> Tipo do componente </TableCell>
              <TableCell> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idIndice}>
                <TableCell> {row.nomeIndice} </TableCell>
                <TableCell>
                  {row.idComponente == 1 && ("Texto")}
                  {row.idComponente == 2 && ("Radio")}
                  {row.idComponente == 3 && ("Select")}
                  {row.idComponente == 4 && ("Marcar")}
                  {row.idComponente == 5 && ("Data")}
                  {row.idComponente == 6 && ("Período")}
                  {row.idComponente == 7 && ("Numérico")}
                  {row.idComponente == 8 && ("Intervalo Numérico")}
                  {row.idComponente == 9 && ("Intervalo Alfabético")}
                </TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.idIndice)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao?.totalCount === 0 && !isLoading && cnpj !== undefined && cnpj !== null && cnpj != '' && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {cnpj === undefined || cnpj === null || cnpj == '' && !isLoading && (
            <caption> Selecione um cliente para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {paginacao?.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={3} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  )
}